module.exports = __webpack_public_path__ + "img/synchronous_and_asynchronous_learnign.419523d9.svg";